import { HistoryEntry, HistoryAction } from './types';

// Take a list of HistoryEntry, combine entries that contain the
// same information (i.e. matching action+context) and only keep
// the newest maxEntriesPerType of each type of action
export function truncate(
  history: HistoryEntry[],
  maxEntriesPerType: number,
): HistoryEntry[] {
  const newHistory: HistoryEntry[] = [];
  const existingEntries: Map<string, HistoryEntry> = new Map();
  const entriesPerType: Map<HistoryAction['type'], number> = new Map();

  history.forEach((entry) => {
    const { action, context, count } = entry;

    const key = JSON.stringify({ action, context });
    const existingEntry = existingEntries.get(key);

    if (existingEntry) {
      existingEntry.count += count;
    } else {
      const currentEntriesPerType = entriesPerType.get(action.type) || 0;
      if (currentEntriesPerType < maxEntriesPerType) {
        const newEntry = { ...entry };

        newHistory.push(newEntry);
        existingEntries.set(key, newEntry);
        entriesPerType.set(action.type, currentEntriesPerType + 1);
      }
    }
  });

  return newHistory;
}
